import { createSelector } from 'reselect';

import { RootState } from '../models';

export const selectIsFullscreenSupported = createSelector(
  (state:RootState) => state.context.isNativeFullscreenSupported,
  (state:RootState) => state.context.isUtilityServiceConnected,
  (isNativeFullscreenSupported:boolean, isUtilityServiceConnected:boolean) => isNativeFullscreenSupported || isUtilityServiceConnected
);